module.exports = __webpack_public_path__ + "img/tylg.df286299.jpg";